import { z } from "zod";

export const importJobStatusSchema = z.discriminatedUnion("status", [
  z.object({ status: z.literal("pending") }),
  z.object({ status: z.literal("processing") }),
  z.object({ status: z.literal("completed"), resumeId: z.string() }),
  z.object({ status: z.literal("failed"), error: z.string() }),
]);

export const importJobCreatedSchema = z.object({
  jobId: z.string(),
});

export type ImportJobStatusDto = z.infer<typeof importJobStatusSchema>;
export type ImportJobCreatedDto = z.infer<typeof importJobCreatedSchema>;
